import { FC, useCallback } from 'react';
import { AgentCallerIdConfirmationModal } from '@pages/agent/InboxPage/components/AgentCallerIdConfirmationModal';
import { useOutboundCallModalContext } from '../OutboundCallModal/context';
import { DYNAMIC_CALLER_ID_NUMBER } from '@components/OutboundCallerIdSelection/constants';
import {
  Contact,
  InteractionContactInput,
  InteractionContactType,
} from '@api/generated/graphql';
import { mainLayoutLocators } from '@locators/main-layout';
import { FeatureFlagKeys, useFeatureFlags } from '@modules/FeatureFlagModule';
import { OutboundCallDetails } from '../OutboundCallModal/types';

export interface TechnicianConfirmationModalProps {
  details: OutboundCallDetails;
  onClose: () => void;
}

export const TechnicianConfirmationModal: FC<
  TechnicianConfirmationModalProps
> = ({ details, onClose }) => {
  const { outboundCall } = useOutboundCallModalContext();
  const {
    [FeatureFlagKeys.featureDisplayTechnicianConversationHistory]:
      featureDisplayTechnicianConversationHistory,
  } = useFeatureFlags();

  const handleCall = useCallback(
    async (callerId: string) => {
      const callerNumber =
        callerId === DYNAMIC_CALLER_ID_NUMBER ? null : callerId || null;
      let contacts: InteractionContactInput[] | undefined;
      if (featureDisplayTechnicianConversationHistory && details.technicianId) {
        contacts = [
          {
            type: InteractionContactType.Technician,
            id: details.technicianId,
            name: details.callDisplayName,
          },
        ];
      }
      await outboundCall({
        phoneNumber: details.number,
        customerName: details.callDisplayName,
        callerNumber,
        tenantId: details.tenantId,
        contacts,
      });
      onClose();
    },
    [
      outboundCall,
      details,
      onClose,
      featureDisplayTechnicianConversationHistory,
    ],
  );

  return (
    <AgentCallerIdConfirmationModal
      customerName={details.callDisplayName}
      contact={{ value: details.number } as Contact}
      tenantId={details.tenantId ?? ''}
      onClose={onClose}
      onCall={handleCall}
      callButtonId={
        mainLayoutLocators.outboundAndTransferModal.technicianCallBtn
      }
    />
  );
};
